import React, { useEffect, useState , useContext} from "react";
import axios, { AxiosResponse } from "axios";
import { config } from "../../contexts/UrlContext";
import { Table, Icon, Dimmer, Loader, SemanticICONS, Popup } from 'semantic-ui-react';
import { requestSort, SORT_ICON, SORT_ORDER } from "../../services/SortService";
import { SettingsContext } from "../../contexts/SettingsContext";
import history from "../../History";
import PaginationNav from "../Results/PaginationNav";
import { toast } from "react-toastify";
import ErrorPage from "../ErrorPage/ErrorPage";
import AuthContext from "../../contexts/AuthContext";
import { getRequest } from "../../services/axiosService";


function StatsPage() {
    const { auth } = useContext(AuthContext);


    const [loading, setLoading] = useState<boolean>(false);
    const [tables, setTables] = useState<any[]>([]);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [activePage, setActivePage] = useState<number>(1);
    const [totalResults, setTotalResults] = useState<number>(0);

    const [sortIcon, setSortIcon] = useState<SemanticICONS>(SORT_ICON.ASC);
    const [sortOrder, setSortOrder] = useState(SORT_ORDER.ASC);
    const [currentSortName, setCurrentSortName] = useState<string>("");

    const { hasStatsPrivileges } = useContext(SettingsContext);

    useEffect(() => {
        async function getData() {
            getTables(1);
        }
        getData();
    }, []);

    const getTables = async (page: number) => {
        setLoading(true);
        try {
            let response: AxiosResponse = await getRequest(auth, `/Stats/GetStatsDisplay?page=${page.toString()}`);

            let data = response.data;

            if (data !== null) {
                setTables(data.results);
                setTotalPages(data.totalPages);
                setTotalResults(data.totalResults);
                setActivePage(page);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            toast.error(`Unable to get CM2WebShare Tables. Please see logs for more info`);
        }

        setLoading(false);
    }

    const handlePaginationChange = async (activePage: number) => {
        setLoading(true);
        setActivePage(activePage);
        await paginateResults(activePage);
        // scroll to top of page
        let mainDiv: any = document.getElementById('site-content');
        mainDiv.scrollTop = 0;
        setLoading(false);
    }

    const paginateResults = async (currentPage: number) => {
        await getTables(currentPage);
    }

    const updateSort = (sortedData: any) => {
        setTables(sortedData);
    }



    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>Loading Statistics...</Loader>
            </Dimmer>
        );
    }
    else if (!hasStatsPrivileges) {
        return (
            <ErrorPage title="Access Denied" message="You do not have access to the Statistics Page" />
        )
    }
    else {
        return (
            <div className="ui container" style={{ borderBottom: "0", maxWidth: "95%", marginTop: 10 }} id="home">
                <div className="header blue headerStyleBlue" style={{marginTop:20}}>Table Statistics</div>
                <div className="subtitle" style={{marginLeft:10, marginBottom:10}}>View refined usage statistics for a CM2WebShare table</div>
                <div className="meta" style={{ marginLeft: 10 }}>Total Results: {totalResults}</div>
                <Table id="homeTable" style={{ marginLeft: 10 }}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell onClick={() => requestSort("name", "string", "name", setCurrentSortName, setSortIcon, setSortOrder, sortOrder, setTables, tables, false)}>
                                Name{currentSortName === "name" ? <Icon name={sortIcon} /> : <Icon name={SORT_ICON.DEFAULT} />}</Table.HeaderCell>
                            <Table.HeaderCell onClick={() => requestSort("description", "string", "description", setCurrentSortName, setSortIcon, setSortOrder, sortOrder, setTables, tables, false)}>
                                Description{currentSortName === "description" ? <Icon name={sortIcon} /> : <Icon name={SORT_ICON.DEFAULT} />}</Table.HeaderCell>
                            <Table.HeaderCell>Actions</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {tables.map(function (table: any) {
                            return (
                                <Table.Row key={table.id}>
                                    <Table.Cell>
                                        {table.shortName !== null && (
                                            <Popup size="small" position="top center" wide trigger={
                                                <div>
                                                    {table.shortName}
                                                </div>
                                            }>{table.name}</Popup>
                                        )}

                                        {table.shortName === null && (
                                            <div>
                                                {table.name}
                                            </div>
                                        )}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {table.shortDescription !== null && (
                                            <Popup size="small" position="top center" wide trigger={
                                                <div>
                                                    {table.shortDescription}
                                                </div>
                                            }>{table.description}</Popup>
                                        )}

                                        {table.shortDescription === null && (
                                            <div>
                                                {table.description}
                                            </div>
                                        )}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <a><Popup content="View Statistics" trigger={<Icon name="eye" alt='View Statistics' id='view' style={{ cursor: 'pointer' }} onClick={() => history.push({ pathname: '/CM2WebShare/TableStats', search: `?id=${table.id}` })} />} /></a>
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </Table.Body>
                </Table>
                <div className="resultsNav" style={{ marginTop: "20px", paddingBottom: "20px" }}>
                    <PaginationNav totalPages={totalPages} onChange={handlePaginationChange} activePage={activePage} />
                </div>
            </div>
        );
    }
}

export default StatsPage;